import * as React from 'react';

export function useOnChange<T>(
  value: T,
  onChange: ({
    current,
    previous,
  }: {
    current: T;
    previous: T | undefined;
  }) => void,
  {
    enableInitialLoad,
  }: {
    enableInitialLoad: boolean;
  } = { enableInitialLoad: false },
) {
  const prevRef = React.useRef<T | undefined>(undefined);
  const mountedRef = React.useRef(false);
  const onChangeRef = React.useRef(onChange);

  // always use latest callback
  React.useEffect(() => {
    onChangeRef.current = onChange;
  }, [onChange]);

  React.useEffect(() => {
    const prev = prevRef.current;

    if (!mountedRef.current) {
      mountedRef.current = true;
      prevRef.current = value;
      if (enableInitialLoad) {
        onChangeRef.current({ current: value, previous: undefined });
      }
      return;
    }

    onChangeRef.current({ current: value, previous: prev });
    prevRef.current = value;
  }, [value]);
}
